<svg width="24" height="24" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_799_20643)">
    <path d="M15.9229 345.043C52.0939 442.527 145.929 512 256 512C366.071 512 459.906 442.527 496.077 345.043L256 322.783L15.9229 345.043Z" fill="#FFDA44"/>
    <path d="M256 0C145.929 0 52.0939 69.472 15.9229 166.957L256 189.217L496.077 166.956C459.906 69.472 366.071 0 256 0Z" fill="black"/>
    <path d="M15.923 166.957C5.633 194.69 0 224.686 0 256C0 287.314 5.633 317.31 15.923 345.043H496.078C506.368 317.31 512 287.314 512 256C512 224.686 506.368 194.69 496.077 166.957H15.923Z" fill="#D80027"/>
  </g>
  <defs>
    <clipPath id="clip0_799_20643">
      <rect width="512" height="512" fill="white"/>
    </clipPath>
  </defs>
</svg>